import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { cx } from '../../utils';
export const useBackdropClasses = ({ className }) => {
    return cx('fixed inset-0 bg-gray-950 bg-opacity-50', className);
};
const Backdrop = forwardRef(({ className, ...rest }, ref) => {
    const backdropClasses = useBackdropClasses({ className });
    return _jsx("div", { ...rest, ref: ref, className: backdropClasses, "data-open": "true" });
});
Backdrop.displayName = 'Backdrop';
export { Backdrop };
//# sourceMappingURL=Backdrop.js.map